import { Component, Input } from '@angular/core';
import { SaldoCliente } from "@shared/models/controlCredito/SaldoCliente";
import { AuthService } from "@authentication/auth.service";
import { DecimalPipe } from "@angular/common";

@Component({
  selector: 'app-reporte-aprobador',
  templateUrl: './reporte-aprobador.component.html',
  styleUrl: './reporte-aprobador.component.scss'
})
export class ReporteAprobadorComponent {
  @Input() checkArray!: string[];
  @Input() cliente!: SaldoCliente;
  @Input() bloquear!: boolean;
  @Input() saldosFiltrados!: SaldoCliente[];

  constructor(public authService: AuthService, public decimalPipe: DecimalPipe){}

  checkSelected(clienteChecked: SaldoCliente) {
    const id = clienteChecked.clienteId;
    const index = this.checkArray.indexOf(id);
    if (index > -1) {
      this.checkArray.splice(index, 1); // Elimina si ya existe
    } else {
      this.checkArray.push(id); // Agrega si no existe
    }
  }
}
